<template>
    <div class="main-banner-hot-carousel-item"
        :style="hotBorder">
        <!-- 图片 -->
        <router-link 
            :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}"
            class="main-banner-hot-carousel-item-img">
            <img v-lazy="item.goods_images[0]" alt="">
        </router-link>
        <div class="main-banner-hot-carousel-item-text">
            <!-- 标题 -->
            <router-link :to="{name: 'pdetail', query:{id: item.goods_id},params:{cate_id:item.cat_id}}"
                class="main-banner-hot-carousel-item-title">
                {{item.goods_name}}
            </router-link>
            <!-- 副标题 -->
            <p class="main-banner-hot-carousel-item-subTitle">
                {{item.goods_brief}}
            </p>
            <!-- 价格 -->
            <p class="main-banner-hot-carousel-item-price" v-if="show_price && powerPrice">
                <span>{{currency}}</span>
				<span>{{item.shop_price}}</span>
            </p>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
    props: [ "item", "hotBorder" ],
    computed: {
        ...mapState({
            currency: state => state.currency,
            show_price: state => state.show_price
        }),
        ...mapGetters([
            'powerPrice',
        ])
    },
}
</script>

<style>
/* 每个项目的样式 */
.main-banner-hot-carousel-item{
    display: flex;
    flex-direction: column;
    border: 1px solid transparent;
    width: 210px;
    height: 360px;
    background-color: #fafafa
}
/* 项目悬停样式 */
.main-banner-hot-carousel-item:hover{
     box-shadow:0 0 20px #ffac13;
}
/* 图片 */
.main-banner-hot-carousel-item-img{
    position: relative;
    display: block;
}
.main-banner-hot-carousel-item-img::before{
    display: block;
    content: "";
    padding-top: 100%;
}
/* 图片样式与动画 */
.main-banner-hot-carousel-item-img>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90%;
    max-height: 90%;
}

/* 文字容器 */
.main-banner-hot-carousel-item-text{
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    padding: 10px;
}
/* 标题 */
.main-banner-hot-carousel-item-title{
    display: block;
    color: #333;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
/* 副标题 */
.main-banner-hot-carousel-item-subTitle{
    width: 100%;
    text-overflow: ellipsis;
    white-space:nowrap;
    overflow: hidden;
    color: #b0b0b6;
}
/* 价格 */
.main-banner-hot-carousel-item-price{
    color: #ff6709;
}
</style>
